import * as React from 'react';
/**
 *
 * Original name: camera upload complete
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=56942%3A894
 *
 */
export const CameraUploadCompletePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m39 19.607 2.828-2.829 3.536 3.536 8.485-8.486 2.829 2.829L45.364 25.97 39 19.607Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20.5 19H9v28a6 6 0 0 0 6 6h34a6 6 0 0 0 6-6V26h-4v21a2 2 0 0 1-2 2H15a2 2 0 0 1-2-2V23h9.797l3.5-6H37v-4H24l-3.5 6Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 35c0 6.73 3.27 10 10 10s10-3.27 10-10-3.27-10-10-10-10 3.27-10 10Zm5.305 4.695C27.935 40.325 29.223 41 32 41s4.065-.675 4.695-1.305C37.325 39.065 38 37.777 38 35s-.675-4.065-1.305-4.695C36.065 29.675 34.777 29 32 29s-4.065.675-4.695 1.305C26.675 30.935 26 32.223 26 35s.675 4.065 1.305 4.695Z", fill: "currentColor" })));
